import { request } from "./network";

export interface RPCResponse<T = unknown> {
    jsonrpc?: string;
    id?: number;
    result?: T;
    error?: string | {
        code: number;
        message: string;
        data?: unknown;
    };
    code?: number;
    message?: string;
    msg?: string;
}

export const rpcApi = {
    call: async <T = unknown>(
        method: string,
        params: unknown = {}
    ): Promise<RPCResponse<T>> => {
        const rpcPayload = {
            jsonrpc: "2.0",
            id: Math.floor(Math.random() * 1000000),
            method,
            params: params || {},
        };

        const response = await request<RPCResponse<T> | { data?: { result?: T; error?: RPCResponse<T>['error'] } }>(
            'POST',
            '/rpc',
            rpcPayload
        );

        if (response && typeof response === 'object' && 'data' in response && response.data && typeof response.data === 'object' && ('result' in response.data || 'error' in response.data)) {
            return response.data as RPCResponse<T>;
        }
        return response as RPCResponse<T>;
    },
    getUserMe: async () => {
        return rpcApi.call("user.me", { include_sessions: true });
    },
    revokeSession: async (sessionId: string, userId: string) => {
        return rpcApi.call("auth.logout", { 
            type: "individual", 
            id: sessionId,
            userid: userId 
        });
    },
    logout: async (type: "current" | "all" | "everywhere", userId?: string, sessionId?: string) => {
        const params: Record<string, string> = { type };
        if (userId) {
            params.userid = userId;
        }
        // For "current" type, session ID is required
        if (type === "current" && sessionId) {
            params.id = sessionId;
        }
        return rpcApi.call("auth.logout", params);
    },
    requestService: async (requests: Array<{ business: string; team: string; service: string; id: string }>) => {
        return rpcApi.call("service.request", requests);
    },
    updateFTP: async (userId: string, ftpData: { status: number; password?: string; email: string }) => {
        return rpcApi.call("user.update", {
            id: userId,
            ftp: ftpData
        });
    },
    rejectServiceRequest: async (requestId: string) => {
        return rpcApi.call("service.reject", {
            id: requestId
        });
    },
    listGroups: async (size = 50, from = 0) => {
        return rpcApi.call("group.list", {
            size,
            from,
            sort: { ct: "desc" },
        });
    },
};

